import React, { useContext, useState } from "react";
import "./Dashboard.css";
import Sidebar from "./Sidebar/Sidebar";
import StudentsSubmission from "../Challenges/StudentsSubmissions/StudentsSubmission";
import Home from "./Content/Home/Home";
import ProblemManagement from "./Content/ProblemManagement/ProblemManagement";
import Accounts from "./Content/Accounts/Accounts";
import ReportsList from "./Content/Reports/ReportsLayout";
import Calendar from "./Content/Calendar/Calendar";
import OutOfService from '../../Error/OutOfService/OutOfService'
import { AuthContext } from "../../context/authContext";
import Error403Layout from "../../Error/Unauthorized/Error.403Layout";

const Dashboard = () => {
  const [NavigationStatus, setNavigationStatus] = useState("Home");
  const {user}=useContext(AuthContext)
  return (
    <div className="Dashboard-container">
      <div className="Siderbar">
        <Sidebar
          setNavigationStatus={setNavigationStatus}
          NavigationStatus={NavigationStatus}
        />
      </div>
      <div className="Body">
        {NavigationStatus === "Home" ? (
          <Home />
        ) : NavigationStatus === "Calendar" ? (
          <Calendar/>
        ) : NavigationStatus === "MySubmissions" ? (
          <OutOfService/>
        ) : NavigationStatus === "AllSubmissions" ? (
          <StudentsSubmission />
        ) : NavigationStatus === "ProblemManagement" ? (
          <ProblemManagement/>
        ) : NavigationStatus === "Accounts" ? (
          user.role.trim().toLowerCase()==="admin"?<Accounts/>: <Error403Layout/>
        ) : (
          <ReportsList/>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
